module.exports = __webpack_public_path__ + "img/icon-info.01f8505e.svg";